import { Chip, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { SKILL_OBJECT } from '../../../constants/props';

const useStyles = makeStyles({
  skill: {
    position: 'relative',
    background: '#1f1f1f',
    color: '#ffffff',
    fontSize: '1rem',
    //maxWidth: '-webkit-fill-available',
    padding: '0.375rem 1.875rem',
    '& .MuiChip-deleteIcon': {
      position: 'absolute',
      right: 0,
    },
    '&:hover :last-child': {
      display: 'inline-block',
    },
  },
});

const Skill = ({ name, onDelete }) => {
  const classes = useStyles();
  return onDelete ? (
    <Chip className={classes.skill} label={name} onDelete={onDelete} style={{height:"100%"}} />
  ) : (
    <Chip className={classes.skill} label={<Typography style={{whiteSpace: 'normal'}}>{name}</Typography>} style={{height:"100%"}} />
  );
};

Skill.defaultProps = {
  onDelete: undefined,
};

Skill.propTypes = SKILL_OBJECT;

export default Skill;
